import { Button, Grid, Link } from "@mui/material";
import projectColors from "../../../../../theme/projectColors";

interface NavItemsProps {
  title: string;
  route: string;
  special?: boolean;
}

function NavItems({ title, route, special }: NavItemsProps) {
  const navigateRoute = () => {
    console.log("Navigate to", route);
  };
  return (
    <Grid
      sx={{
        borderBottom: `solid 2px ${projectColors.primary.main}`,
        transition: "all 0.3s ease",
        "&:hover": {
          borderBottom: special
            ? "none"
            : `solid 2px ${projectColors.primary.light}`,
        },
      }}
    >
      <Link href={route} aria-label={`Ir a ${title}`}>
        <Button
          aria-label={`Navegar a ${title}`}
          onClick={navigateRoute}
          variant={special ? "contained" : "text"}
          color={special ? "info" : "primary"}
          sx={{ color: "white" }}
        >
          {title}
        </Button>
      </Link>
    </Grid>
  );
}

export default NavItems;
